import { render, staticRenderFns } from "./global-revoke-popup.vue?vue&type=template&id=7b872363"
import script from "./global-revoke-popup.vue?vue&type=script&lang=js"
export * from "./global-revoke-popup.vue?vue&type=script&lang=js"
import style0 from "./global-revoke-popup.vue?vue&type=style&index=0&id=7b872363&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports